import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function getStockDiscounts(filters) {
    return await apiRequest({
        url: API_PATHS.getFlashsaleStockDiscounts(filters),
        method: "GET"
    });
}

export async function updateStockDiscounts(data) {
    return await apiRequest({
        url: API_PATHS.updateStock,
        method: "POST",
        data,
    });
}

export async function getStoreProducts(storeId, ruleType = null) {
    return await apiRequest({
        url: API_PATHS.getStoreProducts(storeId, ruleType),
        method: "GET"
    });
}

export async function getLiquidationStockDetails(storeId, data) {
    return await apiRequest({
        url: API_PATHS.getLiquidationStockDetails(storeId),
        method: "POST",
        data
    });
}   